import React from 'react'
import { Outlet, useMatch } from 'react-router-dom'
import styled from 'styled-components'
import { Header } from '../Components/Header/Header'
import { TalesaleSidebar } from '../Components/Sidebar/TelesaleSidrbar'


export const TelasaleLayout = () => {
    let login = useMatch('/login')
    let change = useMatch('/changePassword/:token')
    let dashboard = useMatch('/telesale')
    let match = false;
    if (login || dashboard || change) {
        match = true;
    }
    return (
        <Main>
            <TalesaleSidebar />
            <Container match={match}>
                <Header />
                <OutletSection match={match}>
                    <Outlet />
                </OutletSection>
            </Container>
        </Main>
    )
}

const Main = styled.div`
display: flex;
flex-direction: column;
overflow: hidden;
`
const Container = styled.div`

`

const OutletSection = styled.div`
  width: ${props => props.match ? '100vw' : 'calc(100vw - 20vw)'};
  margin-left: ${props => props.match ? 'none' : '20vw'};
  margin-top: ${props => props.match ? 'none' : '10vh'};
  transition: all 0.3s ease-in-out;
  
  @media (max-width: 1024px) {
    width: ${props => props.match ? '100vw' : 'calc(100vw - 25vw)'};
    margin-left: ${props => props.match ? 'none' : '25vw'};
    margin-top: ${props => props.match ? 'none' : '8vh'};
  }
  
  @media (max-width: 768px) {
    width: ${props => props.match ? '100vw' : 'calc(100vw - 30vw)'};
    margin-left: ${props => props.match ? 'none' : '30vw'};
    margin-top: ${props => props.match ? 'none' : '7vh'};
  }
  
  @media (max-width: 600px) {
    width: 100vw;
    margin-left: 0;
    margin-top: ${props => props.match ? 'none' : '7vh'};
  }
`